import { forwardRef } from "react";

import { INPUT_CLASS_NAME } from "./const";
import { TextFieldProps } from "./type";

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ size = "md", isError = false, ...props }, ref) => (
    <input ref={ref} {...props} className={INPUT_CLASS_NAME({ size, error: isError })} />
  ),
);

TextField.displayName = "TextField";
